export default __webpack_public_path__ + "static/media/truffle.39986cd7.jpg";